import React, { Component } from 'react';
import {validateWorkConfidenceFormFeilds} from '../../utils/validate';
import {FormSubmitError, FormValidationError} from '../../utils/forms/formerror';
import ReCAPTCHA from 'react-google-recaptcha';


class WorkConfidenceForm extends Component {
    
    constructor(props){
        super(props);

        this.state = {
            captcha:{},
            work_confidence_form: {
                first_name: '',
                last_name: '',
                email: '',
            },
            formValidationErrors: [],
        }

        this.captcha =  {};
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setCaptchaObject=this.setCaptchaObject.bind(this);
        this.getRecaptcha= this._getRecaptcha.bind(this);

    }

    setCaptchaObject(grecaptcha){
        this.captcha =  grecaptcha;

    }

    componentDidMount(){
        this.captcha.execute();
    }
    handleInputChange(event) {
        //Needs to be done this way since setstate doesnt merge updates to nested properties
        let work_confidence_form = {...this.state.work_confidence_form};
        work_confidence_form[event.target.name] = event.target.value;

        this.setState({work_confidence_form: {...work_confidence_form}});
    }
    
    handleSubmit(event){
        event.preventDefault();
        //Validate the form fields
        let validate = validateWorkConfidenceFormFeilds(this.state.work_confidence_form);

        if(validate.length > 0){
            return this.setState({formValidationErrors: validate})
        }

        this.props.submitAction(this.state.work_confidence_form,this.state.captcha);
    }


    _getRecaptcha(response) {

        this.setState({
            captcha:response
        })
    }
    
    render() {
        return (
            <div>
                <form className="text-center" name="work_confidence_form" onSubmit={this.handleSubmit} id="work_confidence_form">
                    <h3>Please fill out this form to download</h3>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="firstname"  style={{position: 'absolute',left: '-100000px'}} >First Name:</label>
                                <input name="first_name" onChange={this.handleInputChange} type="text" className="form-control" id="first_name" placeholder={'First Name'} onKeyPress={this.handleEnter} required />
                                <span className="bmd-help"></span>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="last_name"  style={{position: 'absolute',left: '-100000px'}} >First Name:</label>
                                <input name="last_name" onChange={this.handleInputChange} type="text" className="form-control" id="last_name" placeholder={'Last Name'} onKeyPress={this.handleEnter} required />
                                <span className="bmd-help"></span>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <label htmlFor="email"  style={{position: 'absolute',left: '-100000px'}} >Email:</label>
                                <input name="email" onChange={this.handleInputChange} type="email" className="form-control" id="email" placeholder={'Email'} onKeyPress={this.handleEnter} required />
                                <span className="bmd-help"></span>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                    </div>

                    {/* Server Error */}
                    <FormSubmitError 
                        message={this.state.formSubmitErrorMessage}
                    />

                    {/* Form Validation Error */}
                    <FormValidationError 
                        errors={this.state.formValidationErrors}
                    />
                    
                    <br/><br/>
                    <button name="submit" className="btn btn-mid-orange ubuntu" type="submit">
                        <span>Submit</span>
                        <div className={'ripple-container'}></div>
                    </button>
                    &nbsp;
                    <button name="submit" className="btn btn-mid-orange ubuntu" type="button" onClick={this.props.closeButton}>
                        <span>Cancel</span>
                        <div className={'ripple-container'}></div>
                    </button>
                    <ReCAPTCHA
                        ref={(el) => { this.setCaptchaObject(el); }}
                        sitekey={'6LebkXUUAAAAAHkSkfHPiEi8eZAv25K3W8YDzSVG'}
                        onChange={this.getRecaptcha}
                        size='invisible'
                    />
                </form>
            </div>
        );
    }
}

export default WorkConfidenceForm;